import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

// init
var config = {
    apiKey: "AIzaSyDg4luwMtsTR0EB9cBMOamiW8cMU_b8EL0",
    projectId: "brdtheo-moviz",
};
firebase.initializeApp(config);

// instance
export const db = firebase.firestore()

// auth
export const auth = firebase.auth(); 